export default "__VITE_ASSET__BZZEx$2H__"